import DepositoManagementPage from '../pages/DepositoManagementPage'

const routes = [
    { name: 'DepositoManagementPage', path: '/deposito-management', component: DepositoManagementPage },
]

export default routes;

